module.exports = __webpack_public_path__ + "static/img/axial-caldera-colorbar.6fe73b6.png";